export const appConfig = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.lendingusa.com/v1',
  userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID || 'us-west-2_69LJvk8ry',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '7i8o0e622b3m3g0mu464ehb2k3',
  region: process.env.REACT_APP_COGNITO_REGION || 'us-west-2',
  identityPoolId: process.env.REACT_APP_COGNITO_IDENTITYPOOL_ID || 'us-west-2:97b9ced9-fa08-4bc3-bb8d-7472e93803cc',
  limit: process.env.REACT_APP_GRID_PAGE_LIMIT || 10,
  smartyStreetAuthId: '976bb999-dcef-ae9b-0d5d-277754411d04',
  smartyStreetAuthToken: '32906422676442214',
  smartyStreetEnforce: true,
  isSetValueVisible: false,
  apiKey: 'h137FF5Fuq6rNyGnaXsfc8WS9xTH3DUn7Ok72vBS',
  businessUrl: 'https://lendingusa.com',
};
